import { Footer } from './Components/Footer'
import { Container } from './Components/Container'
import { EventDetails } from './Components/EventDetails'
import { SelectionInfo } from './Components/SelectionInfo'
import { SelectionInfoMultiple } from './Components/SelectionInfoMultiple'
import { InnerContainerStyled } from './Components/Common/Common.styles'

export const BetCard = {
  Container,
  InnerContainerStyled,
  EventDetails,
  SelectionInfo,
  SelectionInfoMultiple,
  Footer,
}

export * as FooterButtons from './Components/FooterButtons/FooterButtons'

export type { LinkInfo } from './types'
